import React, { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import './CurrentPriceStyles.css';
import { Card, Col, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { getPrice, updatePrice } from "../../../apis/options/StockPriceApi";

const schema = yup
  .object({
    price: yup.number().required(),
    effectiveStart: yup.date().required(),
    effectiveEnd: yup.date().notRequired()
  })
  .required()



const EditPriceForm = () => {

    let history = useHistory();
    const {priceId} = useParams();

    const [price, setPrice] = useState(null);
    const [isPriceLoading, setIsPriceLoading] = useState(true);

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(schema)
    })

    useEffect(() => {
        async function loadPrice() {
            try {
                const p = await getPrice(priceId);
                if(p.effectiveStart){
                    p.effectiveStart = moment(p.effectiveStart).format("yyyy-MM-DD");
                }
                if(p.effectiveEnd){
                    p.effectiveEnd = moment(p.effectiveEnd).format("yyyy-MM-DD");
                }
    
                setPrice(p);
                setIsPriceLoading(false);
            } catch (error) {
                setIsPriceLoading(false);
            }
        }
    
        loadPrice();
    
    }, [priceId]);

    const update = (data) => 
    {
        updatePrice(priceId, data)
        .then( _ => {
            history.push("/options/stockprice");
        })
        .catch( _ => {
            history.push("/options/stockprice");
        });
    }

    const handleCancel = _ => {
        history.push("/options/stockprice")
    }

    return (
        <Row>
        <Col>
            <Card style={{ width: '18rem' }}>
            <Card.Body>
                <Card.Title>New Price</Card.Title>
                <Card.Text>                
                {isPriceLoading ?
                    <span>Loading price...</span>
                    :
                    <Form noValidate 
                        onSubmit={handleSubmit(update)}> 
                        <Form.Group>
                            <Form.Label>Stock Price</Form.Label>
                            <Form.Control defaultValue={price.price} isInvalid={!!errors.price} type="text" placeholder="Stock Price" {...register("price")} />
                            <Form.Control.Feedback type="invalid">
                            {errors.price?.message}
                            </Form.Control.Feedback>
                        </Form.Group>                  
                        <Form.Group>
                            <Form.Label>Effective Start Date</Form.Label>
                            <Form.Control defaultValue={price.effectiveStart} isInvalid={!!errors.effectiveStart} type="date" placeholder="Start Date" { ...register("effectiveStart")} />
                            <Form.Control.Feedback type="invalid">{errors.effectiveStart?.message}</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Effective End Date</Form.Label>
                            <Form.Control defaultValue={price.effectiveEnd} isInvalid={!!errors.effectiveEnd} type="date" placeholder="End Date" { ...register("effectiveEnd")} />
                            <Form.Control.Feedback type="invalid">{errors.effectiveEnd?.message}</Form.Control.Feedback>
                        </Form.Group>  
                        <Button variant="primary" type="submit">
                            Save
                        </Button>
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                }
                </Card.Text>
            </Card.Body>
            </Card>            
        </Col>
        </Row>
    );

}

export default EditPriceForm;